import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@ui/components/ui/toast";
import { useToast } from "@ui/hooks/use-toast";

export function Toaster() {
    const { toasts } = useToast();

    return (
        <ToastProvider duration={3500} swipeDirection="down">
            {toasts.map(function ({ id, title, description, action, ...props }) {
                return (
                    <Toast key={id} {...props}>
                        <div className="grid gap-1">
                            {title && <ToastTitle>{title}</ToastTitle>}
                            {description && <ToastDescription>{description}</ToastDescription>}
                        </div>
                        {action}
                        <ToastClose />
                    </Toast>
                );
            })}
            <ToastViewport className="fixed bottom-0 left-1/2 -translate-x-1/2 p-4" />
        </ToastProvider>
    );
}
